import React, { useState, useEffect, useRef } from 'react'
import Style from '../acl/acl.module.sass';
import { Table, Input, Switch, Button, Popover, Spin, Icon } from 'antd';
import { Modal } from '../../../helpers/commonUi'
import { Http } from '../../../helpers/axois';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { attachCoreTypeDefs, useToast } from '../../../helpers/commonFunction';
import { ReactComponent as TableEdit } from '../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg'
import { ReactComponent as Tick } from '../../../assets/svg/tick_icon.svg'
import { ReactComponent as Cross } from '../../../assets/svg/cross_icon.svg'
import { ReactComponent as AddIcon } from '../../../assets/svg/add_icon.svg'
import { ReactComponent as SearchIcon } from '../../../assets/svg/search-icon.svg'
import { ReactComponent as GlobeIcon } from '../../../assets/svg/globe.svg'
import "./i18n.css"
import { loadPlugins } from '../../../helpers/MicroFrontend';
import { MARKETPLACE_CORE, MARKETPLACE_CORE_V2 } from '../../../constant/common';
import { initializeA8FormsTypeDefs } from '../../../helpers/typedefinitions/a8forms';
import { setI18NLanguage } from '../../../stateManager/store/i18n/actions';
import NoData from '../NoData';
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import { AppState } from '../../../stateManager/store';


interface LanguageItem {
    key: string;
    language: string;
}

const a8Window: any = window;
const langCode: any = {
    "ENG": "English",
    "HIN": "Hindi",
    "GER": "German",
    "FRE": "French",
    "IND": "Indonesian",
    "TAM": "Tamil",
    "TEL": "Telugu",
    "MAL": "Malyalam",
    "KAN": "Kannadam",
    "MAR": "Marathi",
    "GUJ": "Gujarathi",
    "BEN": "Bengali",
    "ASA": "Assamese",
    "VIE": "Vietnamese",
}

export const Internationalization = () => {
    const dispatch = useDispatch();
    const selectedApp = useSelector((state: any) => state.apps.selectedApp);
    const appType = useSelector((state: any) => state.apps.selectedApp.type);
    const orgId = useSelector((state: any) => state.org.selectedOrg.id);
    const lang = useSelector((state: any) => state.i18n.language);
    const [systemVariables, setSystemVariables] = useState<any>()
    const [component, setComponent] = useState<any>("")
    const [deleteModalVisible, setDeleteModalVisible] = useState(false)
    const [statusModalVisible, setStatusModalVisible] = useState(false)
    const [i18nData, setI18nData] = useState<any>([])
    const [langList, setLangList] = useState<any>([])
    const [i18nLang, setI18NLang] = useState<string>(lang || "ENG")
    const [i18nKey, setI18NKey] = useState<string>("")
    const [i18nVal, setI18NVal] = useState<string>("")
    const [editableKey, setEditableKey] = useState<string>("")
    const [editableVal, setEditableVal] = useState<string>("")
    const [addNew, setAddNew] = useState<boolean>(false)
    const { ErrorToast, SuccessToast } = useToast()
    const [addNewLang, setAddNewLang] = useState<any>()
    const [stat, setStat] = useState<String>()
    const [check, setCheck] = useState<boolean>()
    const [searchValue, setSearchValue] = useState("")
    const [filteredResult, setFilteredResult] = useState<any>([])
    const [langListFiltered, setLangListFiltered] = useState<any>()
    const [searchLang, setSearchLang] = useState<any>()
    const [selectedLang, setSelectedLang] = useState<any>(langCode[lang] + " (" + lang + ")")
    const [searchAvailable, setsearchAvailable] = useState<boolean>(false)
    const [addNewLangList, setAddNewLangList] = useState<any>()
    const [popOpen, setPopOpen] = useState<boolean>(false)
    const [availableList, setAvailableList] = useState<any>()
    const [prevI18n, setPrevI18n] = useState<string>("")
    const [isLoading, setIsLoading] = useState(true);
    const [editData, setEditData] = useState(true);
    const [loadI18N, setLoadI18N] = useState(false);

    const params: { appId?: string } = useParams()
    const appId = params.appId
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    })
    const selectedBranch = useSelector((state: any) => state.apps.appBranch);
    const currentBranchId = appId && selectedBranch && selectedBranch[appId] && selectedBranch[appId].branchId;
    const appVersion = useSelector((state: any) => appId && state.apps?.appVersion?.[appId]);

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    var canViewI18n = (orgPermissions.includes('i18n.View') && orgPermissions.includes('app.View')) || loggedInUserId==selectedOrg?.id;

    const prevVersionIdRef = useRef(versionId);
    const prevI18nLangRef = useRef(i18nLang);

    useEffect(() => {
        if(appVersion && appVersion?.currentVersion){
            setEditData(true)
        } else {
            setEditData(false)
        }
    },[versionId])

    const displayI18N = () => {
        if(!canViewI18n){
            return
        }
        Http.get(`/apps/${appId}/i18n/lang/${i18nLang}?versionId=${versionId}`).subscribe((res: any) => {
            setI18nData(res)
        }, (err) => {
            if (err === "Forbidden") {
                canViewI18n = false
            }
        })
    }

    const getI18NLangList = (versionChanged = false) => {
        if(!canViewI18n){
            return
        }
        Http.get(`/apps/${appId}/i18n?versionId=${versionId}`).subscribe((res: any) => {
            setLangList(res)
            if (res && res.length > 0) {
                res.forEach((lang: any) => {
                    if (lang.language === i18nLang) {
                        setCheck(lang.status === "Active")
                    }
                })
            }

            if (res?.length === 0) {
                // fallback to ENG if no languages are available
                const fallbackLang = "ENG";
                setI18NLang(fallbackLang);
                setSelectedLang(`${langCode[fallbackLang]} (${fallbackLang})`);
                dispatch(setI18NLanguage({ language: fallbackLang }));
                setCheck(false);
                if(versionChanged) {
                    setLoadI18N(true);
                }
            } else if (versionChanged) {
                const existingLang = res?.find((lang: any) => lang.language === i18nLang);
                const lang = existingLang?.language || res[0].language;
                if (!existingLang && lang) {
                    setI18NLang(lang);
                    setSelectedLang(`${langCode[lang]} (${lang})`);
                    dispatch(setI18NLanguage({ language: lang }));
                    const status = res.find((d: any) => d.language === lang)?.status;
                    setCheck(status === "Active");
                } else {
                    setLoadI18N(true)
                }
            }
           
            const langCodeFiltered = Object.fromEntries(Object.keys(langCode).filter(code => {
                return res.some((lang: any) => lang.language === code);
            }).map(code => [code, langCode[code]]))
            setLangListFiltered(langCodeFiltered)

            const langCodesNotInList = Object.keys(langCode).reduce((result: any, code: any) => {
                // Add lang code that are not in langList to the result object
                if (!res.some((lang: any) => lang.language === code)) {
                    result[code] = langCode[code];
                }
                return result;
            }, {});
            setAddNewLang(langCodesNotInList)
        }, (err) => {
            if (err === "Forbidden") {
                canViewI18n = false
            }
        })
    }

    const InsertLanguage = (lang: string) => {
        if ((!orgPermissions?.includes("i18n.Create") || !orgPermissions.includes('app.View')) && loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        const data = {
            language: lang,
            status: 'Active',
            branchId: currentBranchId
        }
        Http.post(`/apps/${appId}/i18n/lang?versionId=${versionId}`, data).subscribe((res: any) => {
            setCheck(true)
            getI18NLangList()
        }, (err) => {
            if (err == "Forbidden") {
                err = "Not Authorized: Please request owner of this organization to provide access"
            }
            ErrorToast(err)
        })
    }

    useEffect(() => {
        const versionChanged = prevVersionIdRef.current !== versionId;
        const langChanged = prevI18nLangRef.current !== i18nLang;

        if (appId && versionId && currentBranchId) {
            if (versionChanged) {
                getI18NLangList(versionChanged);
            }
            if(langChanged) {
                displayI18N();
                getInstalledMarketPlaceWidgets();
            }
        }

        prevVersionIdRef.current = versionId;
        prevI18nLangRef.current = i18nLang;
    }, [versionId, i18nLang]);

    useEffect(() => {
        getI18NLangList(true);
    },[selectedApp])

    useEffect(() => {
        if(loadI18N){
            setLoadI18N(false);
            displayI18N();
            getInstalledMarketPlaceWidgets();
        }
    },[loadI18N])

    useEffect(() => {
        if (i18nData && systemVariables) {
            onFilter();
        }
    }, [i18nData, systemVariables])

    useEffect(() => {
        onFilter()
    }, [searchValue])

    const sysVar: { language: string; key: string; value: any }[] = systemVariables && systemVariables.map((data: any) => {
        return Object.entries(data).map(([key, value]) => ({
            language: i18nLang,
            key: key,
            value: value
        }));
    });
    const reservedVariables = sysVar && sysVar.flat().map((item: any) => item) || []

    const onFilter = () => {
        const reservedKeys = reservedVariables?.map(r => r.key) || [];
        const customi18nData = i18nData?.filter((i: any) => !reservedKeys.includes(i.key)) || []
        reservedVariables?.forEach(r => {
            const v = i18nData.find((i: any) => i.key == r.key)
            if (v) {
                r.value = v.value
            }
        })

        let result = customi18nData.concat(reservedVariables);
        if (searchValue) {
            const regex = new RegExp(`${searchValue}`, 'i');
            result = result.filter((i: any) => regex.test(i.key)) || []
        }

        setFilteredResult(result)
    }

    useEffect(() => {
        searchLanguage();
    }, [searchLang])

    const searchLanguage = () => {
        let r, s = []
        const result: { [key: string]: string } = {}
        if (searchLang) {
            setsearchAvailable(true)
            const regex = new RegExp(searchLang.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i')
            for (const code in langListFiltered) {
                if (langListFiltered.hasOwnProperty(code)) {
                    if (regex.test(langListFiltered[code])) {
                        result[code] = langListFiltered[code];
                    }
                }
            }
            setAvailableList(result)
            s = Object.entries(addNewLang || {}).filter(([code, name]: any) => regex.test(name))
            setAddNewLangList(s)
        } else {
            setsearchAvailable(false)
            r = langList
        }
    }

    const columns = [
        {
            key: 'Key',
            title: 'Key',
            dataIndex: 'key',
            width: '40%',
            render: (record: any) => {
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: "center", fontWeight: 400, fontSize: 13, color: "#292D32", cursor: editData ? "pointer" : "not-allowed" }}>
                        {
                            !addNew ? editableKey === record ? <Input style={{ width: 421, height: 36 }} defaultValue={record} disabled={true}></Input> : record :
                                record != "" ? record : <Input disabled={!editData} style={{ width: 421, height: 36 }} onChange={(e) => { setI18NKey(e.target.value) }}></Input>
                        }
                    </div>
                )
            },

        },
        {
            key: 'Value',
            title: 'Value',
            // dataIndex: 'value',
            width: "40%",
            render: (record: any) => {
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: "center", fontWeight: 400, fontSize: 13, color: "#292D32", cursor: editData ? "pointer" : "not-allowed" }}>
                        {!addNew ? (
                            editableVal === record.value && editableKey === record.key ? (
                                <Input
                                    style={{ width: 421, height: 36 }}
                                    defaultValue={record.value}
                                    disabled={!editData}
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            setPrevI18n(record.value);
                                            setI18NVal(record.value);
                                        } else {
                                            setI18NVal(e.target.value);
                                        }
                                    }}
                                />
                            ) : (
                                record.value
                            )
                        ) : (
                            record.value !== "" ? (
                                record.value
                            ) : (
                                <Input
                                    style={{ width: 421, height: 36 }}
                                    disabled={!editData}
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            setPrevI18n(record.value);
                                            setI18NVal(record.value);
                                        } else {
                                            setI18NVal(e.target.value);
                                        }
                                    }}
                                />
                            )
                        )
                        }
                    </div>
                )
            },
        },
        {
            key: 'component',
            title: 'Component',
            width: "25%",
            render: (record: any) => {
                for (const comp of component) {
                    if (comp.locale) {
                        const localeKeys = Object.keys(comp.locale);
                        for (const key of localeKeys) {
                            if (record.key === key) {
                                return (
                                    <div
                                        style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#3461A21A", color: "#3461A2", height: 24, maxWidth: 119, borderRadius: 4, cursor: editData ? "pointer" : "not-allowed" }}>
                                        {comp.bundleId}
                                    </div>
                                )
                            }
                        }
                    }
                }
                // return (
                //     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#AFAFAF4D", color: "#6B6F7E", height: 24, maxWidth: 119, borderRadius: 4 }}>
                //         custom
                //     </div>
                // );
            }
        },
        {
            key: 'action',
            title: 'Action',
            width: '20%',
            render: (record: any) => {
                const isEditable = !addNew && editableKey === record.key;
                const isReserved = reservedVariables?.some((item: any) => item.key === record.key);

                const editButton = () => (
                    <TableEdit
                        style={{ height: '15px', width: '15px', marginRight: '5px', cursor: editData ? "pointer" : "not-allowed" }}
                        title='Edit'
                        onClick={() => {
                            if (!editData) return;
                            setEditableVal(record.value);
                            setEditableKey(record.key);
                            setI18NKey(record.key);
                            setI18NLang(record.language);
                        }}
                    />
                );

                const createDeleteButton = () => (
                    <Delete
                        style={{ width: '15px', height: '15px', marginLeft: '9px', cursor: editData ? "pointer" : "not-allowed" }}
                        onClick={() => {
                            if (!editData) return;
                            setI18NKey(record.key);
                            setDeleteModalVisible(true);
                        }}
                    />
                );

                const createActionButtons = () => (
                    <div>
                        {isReserved ? (
                            editButton()
                        ) : (
                            <div>
                                {editButton()}
                                {createDeleteButton()}
                            </div>
                        )}
                    </div>
                );

                const createEditButtons = () => (
                    <div style={{ display: 'flex', justifyContent: 'center', cursor: editData ? "pointer" : "not-allowed" }}>
                        <Tick
                            style={{ marginRight: 12 }}
                            title='Save'
                            onClick={() => {
                                if (!editData) return;
                                if (isEditable) {
                                    updateI18N();
                                    setEditableKey('');
                                    setEditableVal('');
                                } else {
                                    createNewI18N();
                                    setAddNew(false);
                                }
                            }}
                        />
                        <Cross title='Discard' onClick={() => { setEditableKey(""); setEditableVal(""); setAddNew(false) }}></Cross>
                    </div>
                );

                return (
                    <div style={{ display: 'flex', alignItems: 'center', cursor: editData ? "pointer" : "not-allowed" }}>
                        {record.key === '' ? (
                            createEditButtons()
                        ) : isEditable ? (
                            createEditButtons()
                        ) : (
                            createActionButtons()
                        )}
                    </div>
                );
            }
        }
    ]

    const createNewI18N = () => {
        if ((!orgPermissions?.includes("i18n.Create") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        const data = {
            language: i18nLang,
            key: i18nKey,
            value: i18nVal,
        }

        const isDuplicate = (reservedVariables && reservedVariables.some((res: any) => res.key === data.key)) ||
            (i18nData && i18nData.some((res: any) => res.key === data.key))

        if (isDuplicate) {
            ErrorToast("Key already exists")
        } else {
            Http.post(`/apps/${appId}/i18n?versionId=${versionId}&branchId=${currentBranchId}`, data).subscribe((res: any) => {
                SuccessToast('I18N created successfully')
                displayI18N()
            }, (err) => {
                if (err === "Forbidden") {
                    err = "Not Authorized: Please request owner of this organization to provide access"
                }
                ErrorToast(err)
            })
        }
        clearValues()
    }

    const clearValues = () => {
        setI18NKey("")
        setI18NVal("")
        setPrevI18n("")
    }

    const updateI18N = () => {
        if ((!orgPermissions?.includes("i18n.Edit") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        const data = {
            value: i18nVal,
        }
        if (i18nVal !== "" && prevI18n !== i18nVal) {
            Http.put(`/apps/${appId}/i18n/lang/${i18nLang}/key/${i18nKey}/?versionId=${versionId}&branchId=${currentBranchId}`, data).subscribe((res: any) => {
                SuccessToast("updated successfully")
                displayI18N()
            }, (err) => {
                if (err === "Forbidden") {
                    ErrorToast("Not Authorized: Please request owner of this organization to provide access")
                } else {
                    ErrorToast(err)
                }
            })
        } else {
            ErrorToast("Nothing to update")
        }
        clearValues()
    }

    const generateModalContent = (visible: boolean, title: string, onCancel: any, onOk: any, message: string, key: string) => (
        <Modal
            key={title}
            visible={visible}
            title={title}
            onCancel={onCancel}
            footer={{
                enable: true,
                okText: 'SUBMIT',
                cancelText: 'CANCEL',
                onOk: onOk
            }}
            unmountOnCancel={false}
        >
            <div key={key} style={{ display: "flex", alignItems: "center", padding: 20 }}>
                {message} <span style={{ fontWeight: "bolder", padding: "0px 0px 0px 5px" }}>{key}</span>?
            </div>
        </Modal>
    );

    const removeRecord = (deleteKey: string) => {
        let response = i18nData.filter((data: any) => data.key != deleteKey)
        setI18nData(response)
    }

    const deleteI18N = () => {
        if ((!orgPermissions?.includes("i18n.Delete") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        Http.delete(`/apps/${appId}/i18n/lang/${i18nLang}/key/${i18nKey}/?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((res: any) => {
            SuccessToast("deleted successfully")
            removeRecord(i18nKey)
        }, (err) => {
            if (err === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast(err)
              }
        })
        setDeleteModalVisible(false)
        clearValues()
    }

    async function totalCoreWidgets(widgetsList = []) {
        try {
            const installedMpWidgets = await widgetsList.map((el: any) => {
                if (el.is_installed === true) {
                    return el.build_id
                }
            }).filter((e: any) => { return e })

            const resp: any = await attachCoreTypeDefs((appType === "a8solo" || appType === "a8chat") ? true : false, true);

            const totalWidgets = [...resp, ...installedMpWidgets];

            const systemVar = totalWidgets
                .flatMap((el) => {
                    if (a8Window?.[el] && a8Window[el].type === "Widget" && a8Window[el].locale) {
                        return a8Window[el].locale
                    }
                    return [];
                })
            const systemComp = totalWidgets
                .flatMap((el) => {
                    if (a8Window?.[el] && a8Window[el].type === "Widget" && a8Window[el].locale) {
                        return a8Window[el]
                    }
                    return [];
                })
            setSystemVariables(systemVar)
            setIsLoading(false)
            setComponent(systemComp)

        } catch (error) {
            console.error(error);
        }
    }


    async function getInstalledMarketPlaceWidgets() {
        if(!canViewI18n){
            return
        }
        loadPlugins(appType === "a8flow" ? MARKETPLACE_CORE : MARKETPLACE_CORE_V2, "marketplaceCore", async () => {
            attachCoreTypeDefs();
            initializeA8FormsTypeDefs();
            try {
                Http.get(`/orgs/${orgId}/store/products?type=widget`).subscribe(async (res: any) => {
                    await totalCoreWidgets(res ? res : [])
                },(err)=>{
                    setIsLoading(false);
                    if (err === "Forbidden") {
                        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
                    }
                })
            } catch (error) {
                console.error(error)
            }
        });
    }

    let newData = [{
        language: i18nLang,
        key: "",
        value: ""
    }]

    const isSelectedLangAvailable = () => {
        const langCode = selectedLang.substring(
            selectedLang.indexOf("(") + 1,
            selectedLang.indexOf(")")
        ).replace(/\s+/g, '');

        return langList.some((lang: any) => lang.language === langCode);
    };
    
    const ChangeLangStatus = () => {
        if ((!orgPermissions?.includes("i18n.Edit") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        let data: any;
        langList.map((e: any) => {
            if (e.language == selectedLang.substring(selectedLang.indexOf("(") + 1, selectedLang.indexOf(")")).replace(/\s+/g, '')) {
                if (e.status == "Active") {
                    setStat("Inactive")
                    data = {
                        status: "Inactive"
                    }
                    setCheck(false)
                } else {
                    setStat("Active")
                    data = {
                        status: "Active"
                    }
                    setCheck(true)
                }
                setStatusModalVisible(false)
            }
        })

        Http.put(`/apps/${appId}/i18n/lang/${i18nLang}?versionId=${versionId}&branchId=${currentBranchId}`, data).subscribe((res: any) => {
            getI18NLangList()
        }, (err) => {
            if (err === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast(err)
              }
        })
    }

    const content = (
        <div style={{ fontWeight: 400, minHeight: 100 }}>
            <div style={{ display: "flex", flexDirection: "row", paddingBottom: 10, alignItems: "center" }}>
                <Input style={{ width: 225, height: 30 }} placeholder='search other languages'
                    onChange={(e: any) => { setSearchLang(e.target.value) }}>
                </Input>
            </div>

            {
                searchAvailable && Object.entries(availableList).length === 0 && addNewLangList.length === 0 ?
                    <Table style={{ width: "100%", height: "100%" }} dataSource={[]} columns={[]}></Table>
                    :
                    <div>
                        <div style={{ maxHeight: 170, overflowY: "auto" }}>
                            {
                                langList && langList.map((e: any) => {
                                    return <div key={e.language} onClick={() => {
                                        setI18NLang(e.language);
                                        if (e.status == "Active") {
                                            setCheck(true)
                                        } else {
                                            setCheck(false)
                                        }
                                    }}
                                    >
                                        <div>
                                            <div>
                                                {(!searchAvailable ? langListFiltered : availableList) && Object.entries(!searchAvailable ? langListFiltered : availableList).map(([code, name]) => {
                                                    if (code == e.language) {
                                                        return (
                                                            <div key={code} onClick={() => {
                                                                setI18NLang(code);
                                                                setSelectedLang(name + " (" + code + ")");
                                                                dispatch(setI18NLanguage({ language: code }));
                                                                setPopOpen(false);
                                                            }} style={{ fontWeight: 400, fontSize: 14 }}>
                                                                <div style={{ display: 'flex', justifyContent: "space-between", paddingRight: 10, paddingBottom: 12 }}>
                                                                    <div>
                                                                        <span style={{ color: "#292D32" }}> {name}</span>
                                                                        <span style={{ color: "#8797A8" }}>{" (" + e.language + ")"}</span>
                                                                    </div>
                                                                    <div style={{ color: e.status === 'Active' ? "#00BE2C" : "#8797A8", fontWeight: 400, fontSize: 14 }}>
                                                                        {e.status}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                })
                            }
                        </div>

                        <div style={{ borderTop: "1px dashed #8797A8", width: 224, display: "flex", justifyContent: "center", alignItems: "center", padding: 10 }}></div>

                        <div style={{ maxHeight: 170, overflow: "auto" }}>
                            {searchAvailable ? addNewLangList && addNewLangList.map((e: any) => {
                                return <div key={e[0].key} style={{ display: "flex", justifyContent: "space-between", paddingBottom: 12, paddingRight: 10, fontWeight: 400, fontSize: 14 }}>
                                    <div style={{ fontWeight: 400, fontSize: 14 }}><span style={{ color: "#292D32" }}>{e[1]}</span><span style={{ color: "#8797A8" }}> {" (" + e[0] + ")"} </span></div>
                                    <AddIcon style={{ cursor: editData ? "pointer" : "not-allowed" }} onClick={() => { if (!editData) return; InsertLanguage(e[0]); setI18NLang(e[0]); setSelectedLang(e[1] + " (" + e[0] + ")"); dispatch(setI18NLanguage({ language: e[0] })); addNewLangList.splice(addNewLangList.indexOf(e[0])) }} />
                                </div>
                            }) : addNewLang && Object.entries(addNewLang).map(([code, name]: any) => {
                                return <div key={code} style={{ display: "flex", justifyContent: "space-between", paddingBottom: 12, paddingRight: 10, fontWeight: 400, fontSize: 14 }}>
                                    <div style={{ fontWeight: 400, fontSize: 14 }}><span style={{ color: "#292D32" }}>{name}</span><span style={{ color: "#8797A8" }}> {" (" + code + ")"} </span></div>
                                    <AddIcon style={{ cursor: editData ? "pointer" : "not-allowed" }} onClick={() => { if (!editData) return; InsertLanguage(code); setI18NLang(code); setSelectedLang(name + " (" + code + ")"); dispatch(setI18NLanguage({ language: code })) }} />
                                </div>
                            })
                            }
                        </div>
                    </div>}
        </div>
    )
    //filter unique items
    const uniqueItems = filteredResult.filter((item: LanguageItem, index: number, self: any[]) =>
        index === self.findIndex((filterVal: LanguageItem) => filterVal.key === item.key && filterVal.language === item.language)
    );

    return (
        <div className='viewWrapper' style={{ fontWeight: 400 }}>
            {canViewI18n ? <div className={Style.content} style={{ padding: "0px 20px" }}>
                <div className={Style.header}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 18, marginTop: 14 }} className={Style.first}>
                        <div>
                            <h4 style={{ fontSize: 14, fontWeight: 600, color: "#052f35 " }}>Internationalization</h4>
                            <h5 style={{ color: "#9D9D9D", fontWeight: 400, fontSize: 13 }}>View, edit or create a internationalization</h5>
                        </div>
                        <div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ paddingBottom: 10, cursor: "pointer" }}>
                                    <Input className="i18n-input" style={{ maxWidth: 167, height: 36 }} prefix={<GlobeIcon style={{ paddingRight: 2 }}></GlobeIcon>} value={selectedLang} onClick={() => popOpen ? setPopOpen(false) : setPopOpen(true)}></Input>
                                </div>
                                <Popover
                                    style={{ width: 245, height: 375, border: "1px solid rgba(125, 132, 146, 0.294)", borderRadius: 6, display: "flex", flexDirection: "column", cursor: "pointer", marginRight: 20 }}
                                    placement='topLeft'
                                    trigger='hover'
                                    visible={popOpen}
                                    onVisibleChange={() => popOpen ? setPopOpen(false) : setPopOpen(true)}
                                    content={content} />
                            </div>
                        </div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Input style={{ width: 312, height: 36, marginRight: 15 }}
                                prefix={<SearchIcon style={{ paddingRight: 4 }}
                                />}
                                placeholder='Search key'
                                onChange={(e: any) =>
                                    setSearchValue(e.target.value)
                                }></Input>
                            <Button
                                style={{ width: 78, height: 36, borderRadius: 4, borderColor: "#052f35 ", color: "#052f35 ", backgroundColor: "#FFFFFF", border: "1px solid #052f35 ", cursor: editData ? "pointer" : "not-allowed", opacity: editData ? 1 : 0.7 }}
                                onClick={() => { editData && setAddNew(true) }}>
                                <span style={{ color: "#052f35 ", fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", fontStyle: "normal", fontSize: 13 }}>Add Key</span>
                            </Button>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", marginRight: 10 }}>{check == true ? "Active" : "Inactive"}</span>
                            <Switch style={{ backgroundColor: check ? "#F1722E" : "#C8CBD1" }} checked={check} disabled={!isSelectedLangAvailable() || !editData} onChange={() => { !check ? ChangeLangStatus() : setStatusModalVisible(true); }}></Switch>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", marginTop: 20 }} className={"row " + Style.Table}>
                    {
                        isLoading ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', width: '100%' }}>
                                <div>
                                    <Spin indicator={
                                        <Icon type="loading" style={{ fontSize: 30, color: '#15808C' }} spin />
                                    } />
                                    <p>Loading...</p>
                                </div>
                            </div>
                            :
                            <Table data-test-id="table_row"
                                columns={columns}
                                pagination={false}
                                scroll={{ y: 'calc(100vh - 240px)' }}
                                onRow={(record: any) => {
                                    return {
                                        'data-test-id': record.key,
                                    }
                                }}
                                className={"table-container"}
                                style={{ width: '100%', display: "flex", alignItems: "center", justifyContent: "space-evenly", opacity: editData ? 1 : 0.7 }}
                                dataSource = {addNew ? [...newData, ...uniqueItems] : uniqueItems}
                            />
                    }
                </div>

                {generateModalContent(deleteModalVisible, "Delete Confirmation", () => {
                    setDeleteModalVisible(false);
                }, deleteI18N, "Do you prefer to remove the key", i18nKey)}

                {statusModalVisible && generateModalContent(statusModalVisible, "Disable Confirmation", () => {
                    setStatusModalVisible(false);
                }, ChangeLangStatus, "Do you prefer to disable the language", i18nLang)}
            </div> : <NoData
                svg={WarningIcon}
                header='Not Authorized'
                content='Please request owner of this organization to provide access'
                noButton={true}
            />
            }
        </div>
    )
}